import { Component, OnInit, Input } from '@angular/core';
import { CorrespondenceTimelineService } from '../../services/correspondence-timeline.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-rename-item',
  templateUrl: './rename-item.component.html',
  styleUrls: ['./rename-item.component.scss']
})
export class RenameItemComponent implements OnInit {

  @Input() timelineItem: any = null;

  newName: string = '';
  renameDisabled: boolean = true;
  loading: boolean = false;
  hasError: boolean = false;
  errorMessage: string = "";

  constructor( public activeModal: NgbActiveModal,
              private correspondenceTimelineService: CorrespondenceTimelineService) {


  }

  ngOnInit(): void {
        if(this.timelineItem.correspondenceTypeId == 2 || this.timelineItem.correspondenceTypeId == 3 )
        this.newName = this.timelineItem.caseFile.fileNameWithoutExtension;
    else
        this.newName = this.timelineItem.summary;

    this.validateForm();
  }

  validateForm(){
      if(this.newName.length > 0)
      this.renameDisabled = false;
  }

  renameItem(){
    this.loading = true;
    this.correspondenceTimelineService.renameItem( this.timelineItem.caseId, this.timelineItem.id, this.newName).subscribe(response => {
      this.loading = false;
      this.activeModal.close(true);
      this.correspondenceTimelineService.refreshCaseTimeline.next();

    }, (error : any) => {

      this.hasError = true;
      this.loading = false;
      this.errorMessage = "Renaming Failed";
      if(error.status == 999)
        this.errorMessage = error.error;
      else
      {
        if (error.error !== null && error.error.message !== undefined) {
          this.errorMessage = error.error.message;
        }
      }


    });
  }

}
